import { css, styled as muiStyled } from '@mui/material/styles';
import React from 'react';
import { useParams } from 'react-router-dom';

import FilterCategory from './filter-category';
import FilterHeader from './filters-header';
import useProjectPolicyLeftNavContext from './left-nav-context';
import { useDashboardDataContext } from '../../project/dashboard/dashboard-context';
import UserNavigationMenu from '../../settings/user-navigation-menu';

import { usePolicyInsightCategories } from '~/client/hooks/policy';
import * as GQL from '~/graphql/generated/client';
import { LeftNavMenu, useLeftNavContext } from '~c/components/base/left-nav';
import { spc } from '~c/components/base/spacer';
import {
  aiDashboardUtils,
  aiSystemPolicyRouteUtil,
  candidateModelPolicyRouteUtil,
  functionalModelsPolicyRouteUtil,
  useDashboardHandlers,
} from '~c/routes';

interface Props {
  className?: string;
}

const AddProjectPolicyLeftNavImpl: React.FC<Props> = ({ className }) => {
  const {
    state: { filters },
    setFilter,
    clearFilters,
    reset,
  } = useProjectPolicyLeftNavContext();
  const project = aiDashboardUtils.useHelper();
  const { state } = useLeftNavContext();
  const { currentRoute } = state;
  const { candidateId, functionalModelId } = useParams();
  const { project: projectData } = useDashboardDataContext();

  const { navigateToMainDashboard } = useDashboardHandlers();
  // Use shared hook to fetch insights + categories
  const { categories } = usePolicyInsightCategories();

  const filteredCategories = React.useMemo(() => {
    if (projectData?.projectType === GQL.ProjectType.Organization) {
      return categories.filter(
        (category) => category.name !== 'Project lifecycle'
      );
    }
    return categories;
  }, [categories, projectData?.projectType]);

  const isFilterSelected = (name: string) => {
    const found = filters.find((filter) => filter.name === name);
    return found ? found.selected : false;
  };

  const routePrefix = {
    [functionalModelsPolicyRouteUtil.routePrefix]:
      functionalModelsPolicyRouteUtil.routePrefix,
    [aiSystemPolicyRouteUtil.routePrefix]: aiSystemPolicyRouteUtil.routePrefix,
    [candidateModelPolicyRouteUtil.routePrefix]:
      candidateModelPolicyRouteUtil.routePrefix,
  };
  return (
    <LeftNavMenu
      className={className}
      name={routePrefix[currentRoute ?? '']}
      header={{
        showBackButton: true,
        onClick: () => {
          reset();
          return navigateToMainDashboard(
            candidateId,
            functionalModelId,
            undefined,
            undefined,
            undefined,
            projectData?.projectType
          );
        },
      }}
    >
      <FilterHeader
        sx={{
          mt: spc.between_vertical_s,
          mb: spc.s,
        }}
      />
      {filteredCategories.map((category) => (
        <FilterCategory
          key={category.name}
          categoryName={category.name}
          filters={category.labels.map((label) => ({
            name: label,
            isSelected: isFilterSelected(label),
            onSelect: (selected) => setFilter({ name: label, selected }),
          }))}
        />
      ))}
      <UserNavigationMenu />
    </LeftNavMenu>
  );
};

const AddProjectPolicyLeftNav = muiStyled(AddProjectPolicyLeftNavImpl)(
  ({ theme }) => css`
    .grow {
      flex-grow: 1;
    }
  `
);

export default AddProjectPolicyLeftNav;
